import * as React from 'react';
import * as _ from 'underscore';

import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';

import { AngularContext } from '../../../ts/factories/AngularContextFactory';
import { AngularDirective } from '../../../common/react/components/AngularDirective';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { IServerStatusScope } from '../../../ts/controllers/ServerStatusCtrl';
import { ServerInfoService } from '../../../serverStatus/services/ServerInfoService';

export interface ServerStatusSpaceProviderProps {
  angularContext: AngularContext;
  renderSpace: (props: ServerStatusSpaceProviderProps, setupScope: (scope: ng.IScope) => IServerStatusScope) => JSX.Element ;
}

const template = `<div ng-controller="ServerStatusCtrl" ng-include="'serverStatus.html'"></div>`;

const ServerStatusSpaceInfo: SpaceInfo = {
  spaceType: 'serverstatus',
  subspaceName: undefined,
  item: SpaceItemForNonEntitySpace
};

export const renderServerStatusSpaceSpace = (props: ServerStatusSpaceProviderProps, setupScope: (scope: ng.IScope) => IServerStatusScope):  JSX.Element => {
  return (
    <ConnectedSpaceInfoProvider spaceInfo={ServerStatusSpaceInfo}>
      {<div>
        <AngularDirective
          template={template}
          angularContext={props.angularContext}
          setupScope={setupScope}
        />
      </div>}
    </ConnectedSpaceInfoProvider>
  );
};

export class ServerStatusSpaceProvider extends React.PureComponent<ServerStatusSpaceProviderProps> {

  // public for unit tests
  public savedChildScope: IServerStatusScope;

  public constructor(props: ServerStatusSpaceProviderProps) {
    super(props);
  }

  public componentDidMount() {
    this.setHosts();
  }

  public render() {
    return this.props.renderSpace(this.props, this.setupScope);
  }

  private setupScope = (scope: ng.IScope) => {
    const childScope = scope.$new() as IServerStatusScope;
    childScope.hosts = [];
    this.savedChildScope = childScope;
    return childScope;
  }

  private setHosts = async () => {
    let hosts = await ServerInfoService.fetch();
    this.savedChildScope.hosts = hosts;
    this.savedChildScope.$digest();
  }
}
